import { fetch as apiFetch } from "../../../Component/function/FunctionApi"; 

const BASE = "Financials";

export const financialsService = {
  getIncomeStatement: (filters = {}) => {
    const params = new URLSearchParams();
    if (filters.from) params.append("From", filters.from);
    if (filters.to) params.append("To", filters.to);
    if (filters.month) params.append("Month", filters.month);
    if (filters.year) params.append("Year", filters.year);
    if (filters.expectedDeliveryPercentage !== "" && filters.expectedDeliveryPercentage != null)
      params.append("ExpectedDeliveryPercentage", filters.expectedDeliveryPercentage);
    if (filters.customProductCostRatio !== "" && filters.customProductCostRatio != null)
      params.append("CustomProductCostRatio", filters.customProductCostRatio);
    if (filters.agencyCommissionPercentage !== "" && filters.agencyCommissionPercentage != null)
      params.append("AgencyCommissionPercentage", filters.agencyCommissionPercentage);

    const query = params.toString();
    return apiFetch(query ? `${BASE}/income-statement?${query}` : `${BASE}/income-statement`);
  },
};